import { AspectRatio } from '@/shadcn-ui/aspect-ratio';
import {
  Body2Skeleton,
  Body3Skeleton,
  BodySkeleton,
  H3Skeleton,
  Skeleton,
} from '@/shadcn-ui/skeleton';
import Spacer from '@/common/components/spacer';
import VehicleTileContainer from './vehicle-tile-container';

export default function VehicleTileSkeleton() {
  return (
    <VehicleTileContainer className="h-full w-full" disable>
      <AspectRatio ratio={4 / 3}>
        <Skeleton className="h-full w-full" />
      </AspectRatio>

      <Spacer variant="height24" />

      <div className="px-[24px]">
        <BodySkeleton className="w-[190px]" />
        <Body2Skeleton multiLine={true} className="w-[140px]" />
        <Spacer variant="height8" />
        <H3Skeleton className="w-[170px]" />
      </div>

      <Spacer variant="height16" />

      <div className="h-px w-full bg-flexcar-neutral80" />

      <div className="px-[24px]">
        <div className="py-[16px]">
          <Body3Skeleton className="w-[70px]" />
        </div>
      </div>
    </VehicleTileContainer>
  );
}
